// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.common with an alias.
import Vue from 'vue'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import App from './App.vue'
import Vue2Filters from 'vue2-filters'
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
import ToastPlugin from './plugins/toast/index'
import router from './router'
import VueHtmlToPaper from '@aedifica/ui-components/src/plugins/vue-html-to-paper'
import * as config from './shared/config/config'
import * as bootstrapVueConfig from './shared/config/config-bootstrap-vue'
import InfiniteLoading from 'vue-infinite-loading'
import LoginService from './account/login.service'
import AccountService from './account/account.service'

import '../content/scss/vendor.scss'
import '@aedifica/ui-components/dist/ui-components.css' // TODO obligé de l'avoir pour un build en mode WAR, est-ce normal ?
import TranslationService from '@/locale/translation.service'
import DossierService from '@/shared/dossier/dossier.service'
import ReferentielService from '@/shared/referentiel/referentiel.service'
import SectionsService from '@/shared/dossier/sections/sections.service'
import RapportService from '@/shared/rapport/rapport.service'

/* tslint:enable */
Vue.config.productionTip = false
config.initVueApp(Vue)
config.initFortAwesome(Vue)
bootstrapVueConfig.initBootstrapVue(Vue)
Vue.use(VueLodash, {lodash})
Vue.use(Vue2Filters)
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(ToastPlugin)
Vue.use(VueHtmlToPaper)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('infinite-loading', InfiniteLoading)
const i18n = config.initI18N(Vue)
const store = config.initVueXStore(Vue)

const translationService = new TranslationService(store, i18n)
const loginService = new LoginService(store)
const referentielService = new ReferentielService(store, i18n)
const rapportService = new RapportService(store, i18n)
const accountService = new AccountService(store, translationService, (<any>Vue).cookie, router)
const dossierService = new DossierService(store, i18n)
const sectionsService = new SectionsService(store)

router.beforeEach((to, from, next) => {
  if (!to.matched.length) {
    return next('/not-found')
  }

  if (to.meta && to.meta.authorities && to.meta.authorities.length > 0) {
    Promise.all([accountService.isAuthorizedToIHM(), accountService.isAuthorizedToPTDDT()]).then(() => {
      if (store.getters.mustLogOntoPtddt) {
        // En cas d'authentification sur l'IHM, et pas sur le portail, on ouvre automatiquement la demande d'autorisation
        // puisque il s'agit de deux ressources différentes (Client OIDC SADCONS = IHM, Client OIDC DATACHAIN = PTDDT)
        loginService.loginPtddt()
      }
      if (store.getters.mustLogOntoIhm) {
        // En cas d'authentification sur le portail, et pas sur l'IHM, on ouvre automatiquement la demande d'autorisation
        // puisque il s'agit de deux ressources différentes (Client OIDC SADCONS = IHM, Client OIDC DATACHAIN = PTDDT)
        loginService.loginIhm()
      }
      return accountService.hasAnyAuthorityAndCheckAuth(to.meta ? to.meta.authorities : null).then((canAccess) => {
        if (!canAccess) {
          sessionStorage.setItem('requested-url', to.fullPath)
          return next('/forbidden')
        }
        return next()
      })
    })
  } else {
    return next()
  }
})

/* tslint:disable */
new Vue({
  el: '#app',
  components: {App},
  template: '<App/>',
  router,
  provide: {
    loginService: () => loginService,

    translationService: () => translationService,
    // jhipster-needle-add-entity-service-to-main - JHipster will import entities services here
    accountService: () => accountService,
    dossierService: () => dossierService,
    referentielService: () => referentielService,
    sectionsService: () => sectionsService,
    rapportService: () => rapportService
  },
  i18n,
  store
})
